"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seamColumnFullWidthProps = exports.seamColumnProps = exports.seamTypes = void 0;
const constants_1 = require("utils/constants");
exports.seamTypes = {
    SET_DATA_GRID: 'SEAM TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'SEAM TYPES ON PAGE CHANGE',
    ON_FILTER_CHANGE: 'SEAM TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'SEAM TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'SEAM TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'SEAM TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'SEAM TYPES ON SAVE DATAITEM',
    ON_DELETE: 'SEAM TYPES ON DELETE',
    SET_ERROR: 'SEAM TYPES SET ERROR',
    SET_LOADING: 'CONTRACTOR TYPES SET LOADING',
    GET_DETAIL: 'AREA TYPES GET DETAIL'
};
exports.seamColumnProps = [
    {
        show: true,
        field: 'area_name',
        title: 'Area Name',
        width: '200px',
        filter: 'text',
    },
    {
        show: true,
        field: 'seam',
        title: 'Seam',
        width: '300px',
        filter: 'text',
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Brand Name',
        width: '200px',
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.seamColumnFullWidthProps = [
    ...exports.seamColumnProps
];
exports.seamColumnFullWidthProps[0] = {
    show: true,
    field: 'area_name',
    title: 'Area Name',
    width: 'auto',
    filter: 'text',
};
exports.seamColumnFullWidthProps[1] = {
    show: true,
    field: 'seam',
    title: 'Seam',
    width: 'auto',
    filter: 'text',
};
exports.seamColumnFullWidthProps[2] = {
    show: true,
    field: 'brand_name',
    title: 'Brand Name',
    width: 'auto',
    filter: 'text',
};
